// extracted by mini-css-extract-plugin
export default {"group":"AuthInput_group__8E+CM","input":"AuthInput_input__IxBgi","label":"AuthInput_label__iM7i1"};